import { Loader, Message } from "tiny-ui";
import "tiny-ui/dist/styles/index.css";
import axios from "axios";
import { useEffect, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import Footer from "./components/footer";
import Header from "./components/header";

const PRODUCT = {
  number: "123456789",
  image: "https://westandwithgaza.com/products/pepsi.jpg",
  company: "Pepsi & Lipton",
  item: "Pepsi Cola - 24/12 Oz. Cans",
  alternatives: [
    {
      number: "456789",
      image: "https://westandwithgaza.com/products/rani-1.jpg",
    },
    {
      number: "456654789",
      image: "https://westandwithgaza.com/products/rani-2.jpg",
    },
    {
      number: "456765489",
      image: "https://westandwithgaza.com/products/rani-3.jpg",
    },
  ],
  banned: true,
};

function Result() {
  const { code } = useParams();
  const navigate = useNavigate();
  const [productName, setProductName] = useState("");
  const [product, setProduct] = useState(null);
  const [reporting, setReporting] = useState(false);

  const submitNewProduct = (code, product) => {
    if (!product) return;
    setReporting(true);
    axios
      .post("https://westandwithgaza.com/api/add-unknown-product", {
        code: code,
        name: product,
      })
      .then((resp) => {
        if (resp.data && resp.data.success) {
          Message.success(resp.data.message, 1000);
          setTimeout(() => {
            Message.loading("Redireting to homepage ...", 500);
            setTimeout(() => {
              navigate("/");
            }, 500);
          }, 1000);
        } else {
          Message.error(resp.data.message);
        }
      });
  };

  useEffect(() => {
    if (!code || code === "test") {
      setProduct(PRODUCT);
      return;
    }
    axios
      .post("https://westandwithgaza.com/api/getProductInfo", {
        code: code,
      })
      .then((resp) => {
        if (resp && resp.data) {
          setProduct(resp.data);
          console.log(resp.data);
        }
      });
  }, []);

  if (!product) {
    return (
      <Loader
        size="lg"
        className="container mx-auto flex justify-center items-center h-screen"
      />
    );
  }

  if (product && product.success == false) {
    return (
      <div className="min-h-screen flex flex-col">
        <Header />

        <form className="mx-auto flex justify-center items-center flex-1 w-3/4 flex-col">
          {/* {JSON.stringify(product)} */}
          <div className="ms:text-xl text-2xl lg:w-3/4 text-center text-wrap">
            This Product does not exist in our database, Please let us know the
            product name below if you know it.
          </div>
          <input
            required={true}
            value={productName}
            onChange={(e) => setProductName(e.target.value)}
            className="w-full lg:w-3/4 rounded-full border-2 p-4 border-gray-400 mt-6"
            placeholder="Enter product name here"
          />

          {reporting ? (
            <Loader className="mt-6" size="md" />
          ) : (
            <button
              className="bg-blue-500 px-10 py-4 mt-6 rounded-full hover:bg-blue-600 text-white"
              onClick={() => submitNewProduct(code, productName)}
            >
              Submit
            </button>
          )}
        </form>

        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col">
      {/* Header */}
      <Header />

      {/* Image Section */}
      <section
        className={`mx-auto mt-6 relative w-80 bg-white border-4 rounded-xl overflow-hidden ${
          product.banned ? "border-red-500" : "border-green-500"
        }`}
      >
        <div className="w-80 h-80">
          <img
            src={product.image}
            alt="product image"
            className="absolute w-80 h-80 object-contain rounded-xl pointer-events-none"
          />
          {product.banned && (
            <img
              src="https://westandwithgaza.com/banned.png"
              alt="product image"
              className="absolute w-80 h-80 object-contain opacity-50 rounded-xl pointer-events-none"
            />
          )}
        </div>

        <h2
          className={`flex justify-center items-center text-center p-4 text-xl h-14 m-0 text-white ${
            product.banned ? "bg-red-500" : "bg-green-500"
          }`}
        >
          {product.banned
            ? "This Product Support Israel"
            : "This Product Does Not Support Israel"}
        </h2>
      </section>
      {/* Large Text Section */}
      <section className="flex-1 py-8 text-center">
        <div className="container sm:w-full lg:w-3/6 md:w-3/4 mx-auto p-4">
          <table className="w-full table-auto rounded-lg border overflow-hidden bg-gray-200">
            <thead>
              <tr className="bg-gray-500">
                <th className="border border-gray-500 px-4 py-2 text-white">
                  Details
                </th>
                <th className="border border-gray-500 px-4 py-2 text-white">
                  Results
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-400 px-4 py-2">
                  Company name
                </td>
                <td className="border border-gray-400 px-4 py-2">
                  {product.company}
                </td>
              </tr>
              <tr>
                <td className="border border-gray-400 px-4 py-2">
                  Product name
                </td>
                <td className="border border-gray-400 px-4 py-2">
                  {product.item}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {product.alternatives && product.alternatives.length != 0 && (
          <div className="container sm:w-full lg:w-3/6 md:w-3/4 mx-auto p-4">
            <div className="mb-4 mt-4 text-left">
              <p className="text-lg text-gray-500">
                See these alternative products
              </p>
            </div>
            <div className="flex overflow-x-auto">
              {product.alternatives?.map((item, index) => {
                return (
                  <img
                    key={index}
                    src={item.image}
                    alt="image"
                    className="w-64 h-64 rounded-xl bg-white border-solid border-4 flex-none object-contain mx-2"
                  />
                );
              })}
            </div>
          </div>
        )}

        <div className="grid gap-5 grid-cols-2 container sm:w-full lg:w-2/6 md:w-3/5 mx-auto p-4 mt-4">
          <Link
            to="/"
            style={{ textDecoration: "none", color: "white" }}
            className="bg-blue-500 py-4 text-lg rounded hover:bg-blue-600"
          >
            Scan Another Product
          </Link>

          <button
            className="bg-green-500 px-10 text-lg py-4 rounded hover:bg-green-600 text-white"
            onClick={() => {
              if (navigator.share) {
                navigator
                  .share({
                    title: "Barcode Scanner",
                    text: "Cut Off Israel Supprting Products",
                    url: window.location.href,
                  })
                  .then(() => console.log("Successfully shared"))
                  .catch((error) => console.error("Error sharing:", error));
              } else {
                alert("Web Share API is not supported in this browser.");
              }
            }}
          >
            Share
          </button>
          {/* <Link
            to="/share"
            style={{ textDecoration: "none", color: "white" }}
            className="bg-green-500 px-10 py-3 rounded hover:bg-green-600"
          >
            Share
          </Link> */}
        </div>
      </section>
      {/* Footer */}
      <Footer />
    </div>
  );
}

export default Result;
